import Topbar from "../../layout/Topbar";
import SettingsSidebar from "../SettingsSidebar";
import {Box, CssBaseline, List, ListItemButton, ListItemText, Paper, useTheme} from "@mui/material";
import React from "react";
import BotRedirect from "./BotRedirect";
import {SettingsContentBox, SettingsRoot} from "../General";
import {settingsPageStyles, SettingsPageHeader} from "../SettingsDesign";
import {NavLink} from "react-router-dom";
import {styled} from "@mui/system";
import BotRules from "./BotRules";

export const SettingsTabContentContainer = styled(Box)(() => ({
    width: "100%",
    padding: 0,
    minWidth: 0,
    margin: "0 auto",
    backgroundColor: "transparent",
    borderRadius: 12,
}));

export const SettingsTabContentPaper = styled(Paper)(() => ({
    minHeight: 200,
    boxShadow: 0,
    padding: "8px 8px",
}));

export const SettingsTabContentPaperTitle = styled(Box)(() => ({
    paddingTop: "8px",
    paddingBottom: "16px",
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: 1.167
}));

function Bot(props) {
    const theme = useTheme();

    return (
        <SettingsRoot>
            <CssBaseline/>
            <Topbar/>
            <SettingsSidebar {...props}/>
            <SettingsContentBox sx={settingsPageStyles}>
                <Box display="flex" flexDirection="column" flexWrap="noWrap" sx={{
                    width: "100%",
                    padding: "24px 30px 0 30px",
                    maxWidth: "1280px",
                    minWidth: 0,
                    margin: "0 auto",
                    [theme.breakpoints.down(600)]: {
                        padding: "16px 0 0"
                    }
                }}>
                    <SettingsPageHeader title="Bot Detection" description="Protect your campaigns from bot traffic and manage detection rules."/>

                    <Box display="flex" className="settings-tabs">
                        <List sx={{display: 'flex', flexDirection: 'row', padding: 0}}>
                            <ListItemButton
                                component={NavLink}
                                to="/settings/bot-detection"
                                selected={props?.location?.pathname === "/settings/bot-detection"}
                                sx={{
                                    borderTopLeftRadius: 4,
                                    borderTopRightRadius: 4,
                                    "&.Mui-selected": {
                                        backgroundColor: "background.defaultBlue",
                                        borderBottomWidth: "2px",
                                        borderBottomStyle: "solid",
                                        borderBottomColor: "primary.main",
                                        marginBottom: "-2px",
                                        ":hover": {
                                            backgroundColor: "background.rowHover"
                                        }
                                    },
                                    ":hover": {
                                        backgroundColor: "background.rowHover"
                                    }
                                }}
                            >
                                <ListItemText primary="Bot traffic"
                                              sx={{fontSize: 14, paddingLeft: 2, paddingRight: 2}}/>
                            </ListItemButton>
                            <ListItemButton
                                component={NavLink}
                                to="/settings/bot-rules"
                                selected={props?.location?.pathname === "/settings/bot-rules"}
                                sx={{
                                    borderTopLeftRadius: 4,
                                    borderTopRightRadius: 4,
                                    "&.Mui-selected": {
                                        backgroundColor: "background.defaultBlue",
                                        borderBottomWidth: "2px",
                                        borderBottomStyle: "solid",
                                        borderBottomColor: "primary.main",
                                        marginBottom: "-2px",
                                        ":hover": {
                                            backgroundColor: "background.rowHover"
                                        }
                                    },
                                    ":hover": {
                                        backgroundColor: "background.rowHover"
                                    }
                                }}
                            >
                                <ListItemText
                                    primary="Bot rules"
                                    sx={{fontSize: 14, paddingLeft: 2, paddingRight: 2}}
                                />
                            </ListItemButton>
                        </List>
                    </Box>
                    <Box display="flex">
                        {props?.match?.isExact && props?.match?.path === "/settings/bot-detection" &&
                            <BotRedirect {...props}/>
                        }
                        {props?.match?.isExact && props?.match?.path === "/settings/bot-rules" &&
                            <BotRules {...props}/>
                        }
                    </Box>
                </Box>
            </SettingsContentBox>
        </SettingsRoot>
    );
}

export default Bot;
